<template>
  <div class="flex-column">
    <div class="block block-rounded block-bordered">
      <ul class="nav nav-tabs nav-tabs-alt js-tabs-enabled" data-toggle="tabs">
        <li class="nav-item">
          <a
            class="nav-link"
            href=""
            :class="{ active: activeTab === 'billing-home' }"
            @click.prevent="loadTab('billing-home')"
            >Accounts</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            href=""
            :class="{ active: activeTab === 'billing-shared' }"
            @click.prevent="loadTab('billing-shared')"
            >Shared Accounts</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            href=""
            @click.prevent="loadTab('billing-transactions')"
            :class="{ active: activeTab === 'billing-transactions' }"
            >Saved Cards</a
          >
        </li>
        <li
          class="nav-item ml-auto"
          v-if="$hasRole('admin') || $hasRole('reseller')"
        >
          <a class="nav-link" href="" @click.prevent="createApiAccount"
            ><i class="fa fa-plus" />
            Create Account
          </a>
        </li>
      </ul>
      <div class="block-content tab-content">
        <div
          class="tab-pane"
          :class="{ active: activeTab === 'billing-home' }"
          role="tabpanel"
        >
          <BillingAccounts :accounts="accounts" />
        </div>
        <div
          class="tab-pane"
          :class="{ active: activeTab === 'billing-shared' }"
          role="tabpanel"
        >
          <BillingAccounts :accounts="sharedAccounts" />
        </div>
        <div
          class="tab-pane"
          :class="{ active: activeTab === 'billing-transactions' }"
          role="tabpanel"
        >
          <h2 class="content-heading mt-0 pt-0">
            <i class="fa fa-angle-right text-muted mr-1" /> Cards ({{
              creditCards.length
            }})
            <a
              href="javascript:void(0);"
              @click="addCreditCard = true"
              class="btn btn-hero-sm btn-hero-success float-right mr-2"
              :to="''"
            >
              <i class="fa fa-credit-card" />
              Add Card
            </a>
          </h2>
          <div class="row" v-if="creditCards.length > 0">
            <div
              class="col-xl-4 js-appear-enabled animated fadeIn"
              data-toggle="appear"
              v-for="(card, index) in creditCards"
              :key="index"
            >
              <credit-card :card="card" />
            </div>
          </div>
          <div class="row" v-else></div>
          <el-dialog
            title="Link Card To Account"
            :visible.sync="addCreditCard"
            width="350px"
            :before-close="() => true"
          >
            <div class="row">
              <div class="col-sm-12 pb-2" v-show="hasErrors">
                <el-alert
                  v-for="(error, index) in validationErrors"
                  :key="index"
                  :title="error[0]"
                  type="error"
                  show-icon
                >
                </el-alert>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <credit-card-field
                  :activity="processing"
                  v-model="checkOutPayload.card"
                  @valid="onValid"
                  @invalid="onInValid"
                  :show-name="true"
                />
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button class="mr-1" @click="handleClose">Cancel</el-button>
              <el-button
                :disabled="!cardIsValid"
                type="primary"
                @click="initiateCardTransaction"
                :loading="processing"
                icon="el-icon-check"
              >
                Verify
              </el-button>
            </span>
          </el-dialog>
        </div>
      </div>
      <create-billing-account />
    </div>
  </div>
</template>

<script>
import BillingAccounts from "./pages/BillingAccount";
import { mapGetters, mapActions } from "vuex";
import CreateBillingAccount from "./pages/CreateBillingAccount";
import CreditCardField from "vue-credit-card-field/src/Components/CreditCardField";
import CreditCard from "./pages/components/CreditCard";

export default {
  name: "MainOverview",
  components: {
    CreateBillingAccount,
    CreditCardField,
    CreditCard,
    BillingAccounts,
  },
  data() {
    return {
      account: {},
      activeTab: "billing-home",
      addCreditCard: false,
      processing: false,
      creditCards: [],
      cardIsValid: false,
      validationErrors: {},
      checkOutPayload: {
        amount: "",
        currency: "KES",
        card: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      accounts: "getAccounts",
      sharedAccounts: "getSharedAccounts",
    }),
    hasErrors() {
      return Object.keys(this.validationErrors).length > 0;
    },
  },
  mounted() {
    this.getAccounts();
    this.getSharedAccounts();
    this.getUserCreditCards();
  },
  methods: {
    createApiAccount() {
      setTimeout(() => {
        jQuery("#create-billing-account").modal({
          backdrop: "static",
          keyboard: false,
        });
      }, 100);
    },
    /**
     *
     */
    getUserCreditCards() {
      axios.get("user/billing/credit-cards").then((res) => {
        this.creditCards = res.data.data;
      });
    },
    onValid() {
      this.cardIsValid = true;
    },

    onInValid() {
      this.cardIsValid = false;
    },

    handleClose() {
      if (!this.processing) {
        this.checkOutPayload.card = {};
        this.addCreditCard = false;
      }
    },

    initiateCardTransaction() {
      this.processing = true;
      this.validationErrors = {};
      axios
        .post("/billing/user/cards", this.checkOutPayload)
        .then((res) => {
          let result = res.data.data;
          if (parseInt(result.Status) === 0) {
            this.$notify({
              message: "The card was successfully linked to your account",
              title: "Operation Successful",
              type: "success",
            });
            this.checkOutPayload.card = {};
            this.getUserCreditCards();
            this.addCreditCard = false;
          } else {
            this.$notify({
              message:
                "Sorry we were not able to verify that the provided credit card details were valid, or your card has insufficient balance",
              title: result.Description,
              type: "error",
            });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.processing = false;
          }, 1500);
        });
    },

    loadTab(title) {
      this.activeTab = title;
      switch (title) {
        case "billing-home":
          this.getAccounts();
          break;
      }
    },
    ...mapActions({
      getAccounts: "getBillingAccounts",
      getSharedAccounts: "getSharedBillingAccounts",
    }),
  },
};
</script>

<style scoped>
</style>
